import React from "react";

import Post_Img_1 from "../../img/news/post_img_1.jpg";
import Post_Img_2 from "../../img/news/post_img_2.jpg";
import Post_Img_3 from "../../img/news/post_img_3.jpg";

function News() {
    const newsList = [
        {
            title: 'Прозорість як стратегія: чому "білий бізнес" стає новою нормою',
            img: Post_Img_1,
            link: 'https://delo.ua/business/prozorist-yak-strategiya-comu-bilii-biznes-staje-novoyu-normoyu-464157/'
        },
        {
            title: 'Business Wisdom Summit 2026: як управлінці переходять від інтуїції до системи – Q&A session про помилки, масштаб і нову роль AI',
            img: Post_Img_2,
            link: 'https://delo.ua/news/business-wisdom-summit-2026-yak-upravlinci-perexodyat-vid-intuyiciyi-do-sistemi-qa-session-pro-pomilki-masstab-i-novu-rol-ai-464391/'
        },
        {
            title: 'Голова ОП про війну, економіку та повернення українців: ключові заяви Буданова',
            img: Post_Img_3,
            link: 'https://delo.ua/news/golova-op-pro-viinu-ekonomiku-ta-povernennya-ukrayinciv-klyucovi-zayavi-budanova-463931/'
        },
    ];

    return (
        <section className="mb-[60px] lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <h2 className="text-[30px] uppercase text-center font-bold xl:text-[55px] mb-10">ЧИТАТИ ПРО BWS</h2>
                <div className="grid gap-14 md:grid-cols-3 mb-12">
                    {newsList.map((item, index) => (
                        <article key={index}>
                            <div className="mb-4">
                                <img  src={item.img}  alt={item.title} className="w-full"
                                />
                            </div>

                            <h3 className="mb-4 font-bold text-xl">
                                {item.title}
                            </h3>

                            <a href={item.link}  target="_blank" rel="noopener noreferrer"
                                className="inline-block text-center text-base bg-[linear-gradient(239deg,_#e6e47c_0%,_#46a37e_49.59%,_#009064_100%)] text-white font-bold px-3 py-2 
                                    tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                                Читати більше
                            </a>
                        </article>
                    ))}
                </div>
                <div className="text-center">
                    <a href="https://delo.ua/tags/events-ekonomika/"  target="_blank" rel="noopener noreferrer"
                        className="inline-block text-center text-base bg-[#ece66a] text-black font-bold px-8 py-3 uppercase
                            tracking-widest hover:scale-105 transition-all duration-300 ease-out">
                        Читати все
                    </a>
                </div>
            </div>
        </section>
    );
}

export default News;